<template>
  <v-app>
    <CheckSessionLoader></CheckSessionLoader>
  </v-app>
</template>

<script>
import CheckSessionLoader from '@/components/auth/checksession-loader.vue'
export default {
  components: {
    CheckSessionLoader
  },
  methods: {
    handleLoginEvent (data) {
      console.log('callback handle login', data)
      this.$router.replace(data.state.target || '/')
    }
  },
  created () {
    /*
    this check is needed, because when this callback route
    is called within the iframe for silent auth0 authentication,
    we do not want to re run renewTokens, it's simply
    for the parent frame, it grabs the redirect url to this
    components hashes.

    So, if we have no hashes, then we can do the renewToken
    which happens immediately after manually loging in
    */
    const hashes = window.location.hash.split('#')
    if (hashes.length <= 1 && hashes[0] === '') {
      this.$auth.renewTokens()
    }
  }
}
</script>

<style>

</style>
